<template>
  <div class="download page dw-btn" data-clipboard-target="#hidInput" @click="bodyClick">
    <!-- <app-bar class="f-s-16" color="#333" background="#FFF" nomenu>
      <div slot="title">首页</div>
    </app-bar> -->
    <!-- <img width="100%" style="width:100%;height:100%;" src="../assets/img/zql/download/d_banner_top.png" /> -->
    <input type="text" id="hidInput" v-model="search">
    <img style="position:absolute;left:0;top:0;width:172px;" src="../assets/img/zql/download/s_ele_left.png" />
    <img style="position:absolute;right:0;top:0;width:84px;" src="../assets/img/zql/download/s_right_top.png" />
    <img style="position:absolute;right:0;top:300px;width:88px;" src="../assets/img/zql/download/s_ele_right.png" />
    <img style="position:absolute;left:0;bottom:0;width:162px;" src="../assets/img/zql/download/s_photo_girl.png" />
    <img style="position:absolute;right:0;bottom:0;width:111px;" src="../assets/img/zql/download/s_photo_boy.png" />

    
    <div class="content-item">
      <img src="../assets/img/zql/download/logo_money.png" class="logo" />
     
      <div style="text-align:center;">
        <img src="../assets/img/zql/download/text_main.png" class="text-main" />
      </div>
      
      <p  style="margin-top: 50px;"></p>
      <p class="inviter">邀请人ID：{{invitor}}</p>
      <p class="inviter" style="display: flex;align-items: center;justify-content: center;"><img src="../assets/img/yqm-txt.png" style="height: 14px;">：{{inviteCode}} <span class="copy-inv" @click="copyTip">点击复制</span></p>

      <a id="href" :href="href" @click="downClick"><span data-clipboard-target="#hidInput" class="down-span" >
        <img src="../assets/img/xzz.png" style="height: 20px;margin-top: 2px;" />
      </span></a>

      <!-- <p class="inviter">search：{{search}}</p>
      <p>url:{{href}}</p> -->
    </div>

    <div id="weixin-tip" class="dsn">
      <img src="../assets/img/zql/download/live_weixin.png" alt="微信打开"/>
    </div>

    <div class="popup-tip" v-if="visiblePop">
      <div class="popup-mask"  @click="closeEv"></div>
      <div class="popup-tip-cont">
        <p><img src="../assets/img/conf-tip.png" style="width: 100%;"></p>
        <div style="padding-top: 30px;">
          <button class="yes-btn" @click="closeEv">确 定</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import appBar from "../components/appBar"
export default {
  components: {
    // appBar
  },
  data() {
    return {
      href: '',
      search:'',
      invitor: '',
      inviteCode: '',
      visiblePop: false,
      appInfo: {}
    }
  },
  methods: {
    closeEv() {
      setTimeout(() => {
        this.visiblePop = false;
      }, 100);
    },
    copyTip() {
      this.$bhUi.Toast({text:'复制成功'})
    },
    async simpleInfo() {
      let res = await this.$axios.get("/user/simpleInfo", {
        params: {
          code: this.$route.params.ivcode
        }
      }).catch(e => {
        console.log('exception: ',e);
      })
      if (res.code === 200 && res.data) {
        this.invitor = res.data.userId;
        this.inviteCode = res.data.inviteCode;
        this.appInfo = res.data;
      }
    },
    copy(text) {
      let oTextarea = document.createElement('textarea')
      oTextarea.value = text
      document.body.appendChild(oTextarea)
      oTextarea.select()
      document.execCommand("Copy")
      oTextarea.className = 'oTextarea'
      oTextarea.style.display='none'
      oTextarea.parentNode.removeChild(oTextarea)
      console.log('COPY SUCCESS');
    },
    copyParmas() {
      let {appId = 1, id = '', chlCode = 'h5'} = this.appInfo || {};
      console.log('before chlCode>> ', chlCode);

      if (chlCode) {
        if (Array.isArray(chlCode)) {
          chlCode = chlCode[0] 
        } else if (chlCode.includes(',')) {
          chlCode = chlCode.split(',')[0]
        }
      }

      let params = `id=${id}&appId=${appId}&chlCode=${chlCode}`
      this.search = `ZQL##&${params}`;
      // ZQL##&id=xxx&chlCode=xxx
      console.log('params>> ', this.$route.query);
      this.copy(`ZQL##&${params}`)
    },
    getDownUrl() {
      var isIos = !!navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)
      var isIphone = /(iPhone|iPad|iPod|iOS)/ig.test(navigator.userAgent)
      var iosPlatform = /^(iPhone|iPad|iPod|Pike)/ig.test(navigator.platform) 
      var ios11 = !!navigator.userAgent.match(/Intel Mac OS X/)

      if (isIos || iosPlatform || isIphone || ios11) {
        isIos = true;
      }
      this.isIos = isIos
      
      let down = window.downUrl
      if (window.downUrl) {
        down = window.downUrl['zql']
        if (isIos) {
          return down.ios;
        }
        return down.Android;
      } 
      //   if (isIos) {
      //     // return 'https://www.rtian.net/apps/ios_down.html';
      //     return 'https://apps.apple.com/cn/app/id6449017807';
      //   }
      //   return 'https://img.youchent.com/apks/1/hzb-1.1.4-signed.apk'
    },
    is_wechat_client() {
      var ua = navigator.userAgent.toLowerCase()
      if (ua.match(/MicroMessenger/i)=="micromessenger"){
        return true
      } else {
        return false
      }
    },
    bodyClick() {
      this.copyParmas();
    },
    downClick() {
      this.copyParmas();
      if (this.is_wechat_client()) {
        document.getElementById('weixin-tip').className = '';
        return;
      }
      if (!this.href) {
        location.href = this.getDownUrl();
      }
    },
    initEv() {
      // this.copyParmas();
      if (!this.is_wechat_client()) {
        this.href = this.getDownUrl()
      } else {
        this.href = 'javascript:;'
      }
    }
  },
  async mounted() {
    var isIos = !!navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)
    var isIphone = /(iPhone|iPad|iPod|iOS)/ig.test(navigator.userAgent)
    var iosPlatform = /^(iPhone|iPad|iPod|Pike)/ig.test(navigator.platform) 
    var ios11 = !!navigator.userAgent.match(/Intel Mac OS X/)

    if (isIos || iosPlatform || isIphone || ios11) {
      isIos = true;
    }

    let { ivcode } = this.$route.params || {}
    console.log('解析参数》》》', this.$route.params, ivcode, this.$route.query);
    
    await this.simpleInfo();

    let i = 1
    let timer = setInterval(() => {
      if (i > 10) {
        clearInterval(timer);
      } else if (this.href) {
        clearInterval(timer)
      }
      i++;
      this.initEv();
    }, 1000)

    setTimeout(() => {
      if (!this.is_wechat_client() && !isIos) {
        this.visiblePop = true;
      }
    }, 500)
    
    if (!this.is_wechat_client()) {
      this.href = this.getDownUrl()
    } else {
      this.href = 'javascript:;'
    }

    document.getElementById('weixin-tip').addEventListener('click', function () {
      document.getElementById('weixin-tip').className = 'dsn';
    })

    if (window.ClipboardJS) {
      try {
        var clipboard = new window.ClipboardJS('.dw-btn');
        clipboard.on('success', function(e) {
          console.info('Action:', e.action);
          console.info('clipboard 成功 Text:', e.text);
          console.info('Trigger:', e.trigger);
          e.clearSelection();
        });

        clipboard.on('error', function(e) {
          console.error('Action:', e.action);
          console.error('Trigger:', e.trigger);
          console.info('clipboard 失败:', e);
        });
      } catch (error) {
        console.log(error);
      }
    }
  }
}
</script>


<style lang="less" scoped>
.page{
  height: 100%;
  overflow: hidden;
  background:linear-gradient(0deg,rgba(255,99,27,1) 0%,rgba(254,107,29,1) 68%,rgba(255,97,52,1) 84%,rgba(254,163,14,1) 100%);
  
  .content-item{
    position: absolute;
    top: 40px;
    left: 0;
    width: 100%;
    text-align: center;

    .logo {
      width: 150px;
      height: 150px;
      // width: 80px;
      // height: 80px;
      // border-radius: 10px;
      // margin-bottom: 40px;
      // margin-top: 30px;
    }
    .text-main {
      width: 150px;
    }
      
    a{
      display: inline-block;
      font-weight: 600;
      font-size: 16px;
      width: 250px;
      height: 38px;
      margin: 52px 0 63px;
      line-height: 38px;
      background: linear-gradient(90deg, #FEAA00 0%, #FFD105 100%);
      border-radius: 54px;
      color: #fff;
    }
    .down-span {
      width: 250px;
      height: 38px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .inviter {
      text-align: center;
      color: #fff;
    }
    .copy-inv {
      background: linear-gradient(90deg, #FEAA00 0%, #FFD105 100%);
      display: inline-block;
      padding: 0 4px;
      border-radius: 4px;
      margin-left: 4px;
      font-size: 12px;
    }
    .inv-tip {
      font-size: 12px;
      color: #fff;
    }
  }

  #weixin-tip{
    position: fixed; 
    left:0; 
    top:0; 
    background: rgba(0,0,0,0.8);
    filter:alpha(opacity=80);
    width: 100%;
    height:100%;
    z-index: 100;
    text-align: center;
  } 
  #weixin-tip p{
    text-align: center;
    margin-top: 10%; 
    padding:0 5%;
  }
  #weixin-tip img{
    margin-top: 6px;
    width: 98vw;
  }
  .dsn{
    display: none;
  }

  #hidInput{
    opacity: 0;
    position: absolute;
    top: -1000px;
    left: 0;
    z-index: 1;
  }

  .popup-tip {
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    z-index: 10;
    .popup-mask {
      position: absolute;
      left: 0;
      top: 0; 
      width: 100%;
      height: 100%;
      z-index: 1;
      background: rgba(0,0,0,0.8);
    }
    

    .popup-tip-cont {
      position: absolute;
      top: 50%;
      left: 54px;
      right: 54px;
      background: #fff;
      border-radius: 8px;
      padding: 20px 14px;
      text-align: center;
      z-index: 20;
      transform: translateY(-50%);

      .cancel-btn {
        background: #fff;
        font-size: 12px;
        color: grey;
      }
      .yes-btn {
        background: #FF9900;
        font-size: 12px;
        color: #fff;
        padding: 3px 10px;
        border-radius: 4px;
      }
    }

  }
}
</style>